import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import template from './templates/HintBox.html?raw';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domConstruct from 'dojo/dom-construct';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import query from 'dojo/query';
// NOTE (JS2TS): original define() also listed dojo/dijit/dojox deps never referenced in code and not
// used via data-dojo-type (connect, array, Color, keys, dijit _WidgetBase/_TemplatedMixin/
// _WidgetsInTemplateMixin, registry, on, form/TextBox, form/Button, Menu, MenuItem, form/ComboButton,
// Toolbar, request/xhr, dojox Standby, mouse, dom-style) — dead, dropped.

class HintBox extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    currentFocus: any = null;
    _hintboxList: any = null;

    labelAttribute: any = null;
    suggestionLabelAttribute: any = null;
    filterPath: any = null;
    searchParam: any = null; // name des Parameters im Filter ( => pit-Filter)
    requestUrlSearchParameter = "searchValue"; // name des Parameters der über die Url als Http-Request gesendet wird (=> Controller)
    resetOnEdit = false; // das Entity zurücksetzen wenn der Benutzer eine Eingabe macht (also Inputfeld irgendwie reintippt)

    __request: any = null;
    __searchDelay: any = null;
    _plainvalue: any = null; // zum Vergleichen: was steht im Input nach der Entityauswahl und hat der Benutzer was reingetippt?

    entities: any = [];
    url: any = null;
    minLetterCount = 3;
    selectedEntity: any = null;
    limit = 10;
    dataformat = "pit"; // wird für Request und Response benötigt (pithelper)
    readonly = false;

    mandatoryNodeName = "input";

    _constructDefaultUrl(): any {
        if (this.suggestionLabelAttribute == null) {
            this.suggestionLabelAttribute = this.labelAttribute;
        }
        //return "Entity/GetFilterEntityListData" + '?filterPath=' + this.filterPath + '&searchParam=' + this.searchParam + '&jsonAttributeNames=["' + this.labelAttribute + '"]'+ '&limit=' + this.limit;
        return "Entity/GetFilterEntityListData" + '?filterPath=' + this.filterPath + '&searchParam=' + this.searchParam + '&jsonAttributeNames=["' + this.labelAttribute + '", "' + this.suggestionLabelAttribute + '"]' + '&limit=' + this.limit;
    }

    _setReadonlyAttr(value: any): void {
        this.readonly = value;
        domAttr.set(this.input, "disabled", this.readonly);
    }

    _setMandatoryAttr(value: any): void {
        this.mandatory = value;
        //this.checkValidity();
    }

    _setDataFormatAttr(value: any): void {

        if (value != "pit" && value != "json") {
            value = "json";
        }

        this.PitHelper._structureFormat = value;

        this.dataformat = value;
    }

    _getValueAttr(): any {
        return this.selectedEntity;
    }

    _setValueAttr(value: any, bSuppressChange?: any): void {

        //console.log("hintbox _setValueAttr", value, bSuppressChange, this.input.value, this._plainvalue);

        this.selectedEntity = value;
        this.checkValidity();

        if (value == null) {
            if (this._plainvalue != null) {
                this.input.value = null; // dann wird halt auch beim Eintippen (Reset) sofort alles gelöscht, blöd; allerdings weiß der Benutzer dann dass Entity leer
            }
            this._plainvalue = null;

            if (bSuppressChange !== true) {
                this.emit("change", value);
            }
        }
        else {
            this.input.value = this.PitHelper.getEntityAttributeValue(this.selectedEntity, this.labelAttribute, this.dataformat as any);
            this._plainvalue = this.input.value;

            if (bSuppressChange === true) {

            } else {
                this.emit("change", value);
            }
        }
    }

    _loadListValues(searchText?: any): void {

        //  bei jeder Textänderung erstmal das selectedEntity entfernen
        //
        this.selectedEntity = null;
        this.checkValidity();

        if (searchText == null) {
            return;
        }
        if (searchText.length < this.minLetterCount) {
            return;
        }

        // das attribut wird in den Vorschlägen angezeigt
        // damit kann getrennt gesteuert werden, wie ein Objekt im Dropdown aussieht und
        // welcher Wert dann wirklich in der Hintbox stehen bleibt
        if (this.suggestionLabelAttribute == null) {
            this.suggestionLabelAttribute = this.labelAttribute;
        }

        var url;
        if (this.url == null) {
            url = this._constructDefaultUrl();
        } else {
            url = this.url;
        }

        var sFirstParamDelmiter = "?";
        if (url.indexOf("?") > -1) {
            sFirstParamDelmiter = "&";
        }

        if (this.__request != null) {
            this.__request.cancel();
        }

        this.StandbyStart();

        url = (window as any).appRoot + url + sFirstParamDelmiter + this.requestUrlSearchParameter + '=' + searchText;

        // bei json-Format zusätzlich die angezeigten Attribute mitliefern, damits in da json-dokument eingefügt werden kann
        //(API-Funktion muss sich aber drum kümmern...)
        if (this.dataformat == "json") {
            url = url + '&jsonAttributeNames=["' + this.labelAttribute + '", "' + this.suggestionLabelAttribute + '"]';
        }

        this.__request = this.RequestManager.get(
            url, //@TODO: alles was der SelectEntityButton kann auch hier als parameter mitgeben
            lang.hitch(this, function (response: any) { // responsecallback

                // ist entweder klassisches pit-Datarray oder json-Array aus API
                if (this.dataformat == "pit") {
                    this.entities = response.EntityDataArray;
                } else if (this.dataformat == "json") {
                    this.entities = response;
                    if (typeof (response) == "string") {
                        this.entities = JSON.parse(response);
                    }
                }

                //console.log("hintbox response", typeof (response), this.entities);

                this._handleSearch(); // eigentliche suche mit Textvergleich im Javascript der mit den zurückgelieferten Entities arbeitet

                this.StandbyStop();
            }),
            lang.hitch(this, function (err: any) { // errorCallback

                if (typeof (err) == "object") {
                    alert(err.Message);
                } else {
                    alert(err);
                }
                this.StandbyStop();
            })
        );
    }

    _handleSearch(): any {

        var a, b, i, val = this.input.value;

        this.closeAllLists();
        if (!val) { return false; }

        this.currentFocus = -1;

        //  Container für Vorschläge
        //
        this._hintboxList = document.createElement("DIV");
        this._hintboxList.setAttribute("class", "hintbox-items");

        //this.input.parentNode.appendChild(this._hintboxList);
        domConstruct.place(this._hintboxList, this.input, "after");

        for (i = 0; i < this.entities.length; i++) {
            var entity = this.entities[i];
            var itemLabel = this.PitHelper.getEntityAttributeValue(entity, this.suggestionLabelAttribute, this.dataformat as any);

            if (itemLabel == null) {
                itemLabel = "missing value for '" + this.suggestionLabelAttribute + "' in '" + this.PitHelper.getEntityAttributeValue(entity, "ID", this.dataformat as any) + "'";
            }

            //  Textvergleich der geladenen Items mit eingegebenem String
            //
            var searchtermStartIndex = itemLabel.toUpperCase().indexOf(val.toUpperCase());
            //if (searchtermStartIndex > -1) {

            // für alle gefundenen Items ein Element im Vorschlagscontainer erstellen
            //
            b = document.createElement("DIV");

            if (this.entities.length == 1) {
                domClass.add(b, "hintbox-active");
            }
            //  markieren der Textübereinstummengen
            //
            if (searchtermStartIndex > -1) {
                var leftPart = itemLabel.substr(0, searchtermStartIndex);
                var midPart = "<strong>" + itemLabel.substr(searchtermStartIndex, val.length) + "</strong>";
                var rightPart = itemLabel.substr(searchtermStartIndex + val.length);

                b.innerHTML += leftPart + midPart + rightPart;
            }
            else {
                b.innerHTML += itemLabel;
            }
            b.innerHTML += "<input type='hidden' value='" + JSON.stringify(entity) + "'>";

            b.addEventListener("click", lang.hitch(this, function (listElement: any, e: any) {

                var jsonEntity = (query("input", listElement)[0] as any).value;
                this.set("value", JSON.parse(jsonEntity));

                this.closeAllLists();
            }, b));
            this._hintboxList.appendChild(b);
            //}
        }
    }

    _setupEventListener(): void {

        //  "input" klappt im dojo-template nicht?!?!
        //
        this.input.addEventListener("input", lang.hitch(this, "_onInput"));

        //  click irgendwo im dokument schließt die vorschläge
        //
        document.addEventListener("click", lang.hitch(this, function (this: any, e: any) {
            this.closeAllLists(e.target);
        }));
    }

    _onInput(evt: any): void {
        if (this.__searchDelay != null) {
            clearTimeout(this.__searchDelay);
        }

        this.__searchDelay = setTimeout(lang.hitch(this, function () {
            this._loadListValues(this.input.value);
        }), 200);
    }

    openAllEntries(): void {
        this.input.value = "%";
        this._loadListValues(this.input.value);
    }

    _onKeyDown_Input(evt: any): void {
        var x = this._hintboxList;

        if (x) x = x.getElementsByTagName("div");
        if (evt.keyCode == 40) {
            this.currentFocus++;
            this.addActive(x);
        } else if (evt.keyCode == 38) { //up
            this.currentFocus--;
            this.addActive(x);
        } else if (evt.keyCode == 13) {
            evt.preventDefault();
            if (this.currentFocus > -1) {
                //  focus auf item gesetzt
                //
                if (x) x[this.currentFocus].click();
            } else {
                //  kein focus auf item
                //
                if (x.length == 1) {
                    x[0].click();
                }
            }
        } else if (evt.keyCode == 27) { //esc
            this.closeAllLists();
        }
    }

    // wenn ein Benutzer einen Hint auswählt, aber danach die Inputbox ändert, kann evtl ja die ganze Auswahl ungültig sein
    // deswegen einmalig ein Event auslösen
    _onKeyUp_Input(evt: any): void {

        if (this._plainvalue != this.input.value && this._plainvalue != null) {
            this.emit("inputEdit", this.input.value);
            //this._plainvalue = null;

            if (this.resetOnEdit === true) {
                this.set("value", null);
            }
        }

    }

    addActive(hintboxItems: any): any {
        if (!hintboxItems) return false;
        this.removeActive(hintboxItems);
        if (this.currentFocus >= hintboxItems.length) this.currentFocus = 0;
        if (this.currentFocus < 0) this.currentFocus = (hintboxItems.length - 1);

        domClass.add(hintboxItems[this.currentFocus], "hintbox-active");
    }

    removeActive(hintboxItems: any): void {
        for (var i = 0; i < hintboxItems.length; i++) {
            domClass.remove(hintboxItems[i], "hintbox-active");
        }
    }

    closeAllLists(elmnt?: any): void {
        var x = query(".hintbox-items", this.domNode);
        for (var i = 0; i < x.length; i++) {
            if (elmnt != x[i] && elmnt != this.input) {
                x[i].parentNode.removeChild(x[i]);
            }
        }
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (this.suggestionLabelAttribute == null) {
            this.suggestionLabelAttribute = this.labelAttribute;
        }

        this._setupEventListener();
        //this.checkValidity();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
}
HintBox.prototype.declaredClass = 'more.HintBox';

export default mdsWidget(HintBox);
